export const normalizeDisclosure = (disclosure = {}) => ({
  code: disclosure.code,
  title: disclosure.title,
  inputType: disclosure.inputType,
  topic: disclosure.topic,
  unit: disclosure.defaultUnit || disclosure.unitOptions?.[0] || "",
  masterMetricId: disclosure.masterMetricId || null,
  category: disclosure.category,
  framework: disclosure.framework,
  parentCode: disclosure.parentCode,
  hasSubEntries: disclosure.hasSubEntries,
  subEntries: disclosure.subEntries || [],
  isQuantitative: Boolean(disclosure.isQuantitative),
});

export const getDisclosureIdentifier = (disclosure = {}) => {
  if (disclosure.masterMetricId) {
    return String(disclosure.masterMetricId).toUpperCase();
  }
  return `${disclosure.framework}_${disclosure.code || "UNKNOWN"}`.toUpperCase();
};

export const getSuggestedBaseline = (disclosure = {}) => {
  const unit = String(disclosure.unit || "").toLowerCase();

  if (unit.includes("co2")) {
    return 5000;
  }

  if (unit.includes("mj") || unit.includes("kwh")) {
    return 120000;
  }

  if (unit.includes("m3") || unit.includes("l")) {
    return 15000;
  }

  if (unit.includes("%")) {
    return 50;
  }

  return 1000;
};

/**
 * Gets description from disclosure (handles both string and object formats)
 * - Custom disclosures: string
 * - Standard disclosures: object with { summary, guidance, examples, etc. }
 */
export const getDisclosureDescription = (disclosure = {}) => {
  if (!disclosure.description) {
    return "";
  }

  // Custom disclosure - simple string
  if (typeof disclosure.description === "string") {
    return disclosure.description;
  }

  // Standard disclosure - object with summary
  return disclosure.description.summary || "";
};
